import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface ArchivagePopupMessageParams {
  openPopup: boolean;
  handleAgreeButton: () => void;
  handleDesagreeButton?: () => void;
}

export default function ArchivagePopupMessage({
  openPopup,
  handleAgreeButton,
  handleDesagreeButton
}: ArchivagePopupMessageParams) {

  const handleCloseDialog = () => {
    if (handleDesagreeButton) {
      handleDesagreeButton();
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={openPopup}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Demande d'archivage du projet"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Êtes vous sûr de vouloir archiver ce projet ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Non</Button>
          <Button onClick={handleAgreeButton} autoFocus>
            Oui
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}